const languages = [
    {
        "code": "af",
        "tw": "南非荷蘭文",
        "de": "Afrikaans",
        "jp": "アフリカーンス語",
        "cn": "南非荷兰语",
        "en": "Afrikaans"
    },
    {
        "code": "am",
        "tw": "阿姆哈拉文",
        "de": "Amharisch",
        "jp": "アムハラ語",
        "cn": "阿姆哈拉语",
        "en": "Amharic"
    },
    {
        "code": "ar",
        "tw": "阿拉伯文",
        "de": "Arabisch",
        "jp": "アラビア語",
        "cn": "阿拉伯语",
        "en": "Arabic"
    },
    {
        "code": "as",
        "tw": "阿薩姆文",
        "de": "Assamesisch",
        "jp": "アッサム語",
        "cn": "阿萨姆语",
        "en": "Assamese"
    },
    {
        "code": "az",
        "tw": "亞塞拜然文",
        "de": "Aserbaidschanisch",
        "jp": "アゼルバイジャン語",
        "cn": "阿塞拜疆语",
        "en": "Azerbaijani"
    },
    {
        "code": "be",
        "tw": "白俄羅斯文",
        "de": "Belarussisch",
        "jp": "ベラルーシ語",
        "cn": "白俄罗斯语",
        "en": "Belarusian"
    },
    {
        "code": "bg",
        "tw": "保加利亞文",
        "de": "Bulgarisch",
        "jp": "ブルガリア語",
        "cn": "保加利亚语",
        "en": "Bulgarian"
    },
    {
        "code": "bn",
        "tw": "孟加拉文",
        "de": "Bengalisch",
        "jp": "ベンガル語",
        "cn": "孟加拉语",
        "en": "Bangla"
    },
    {
        "code": "bs",
        "tw": "波士尼亞文",
        "de": "Bosnisch",
        "jp": "ボスニア語",
        "cn": "波斯尼亚语",
        "en": "Bosnian"
    },
    {
        "code": "ca",
        "tw": "加泰蘭文",
        "de": "Katalanisch",
        "jp": "カタロニア語",
        "cn": "加泰罗尼亚语",
        "en": "Catalan"
    },
    {
        "code": "cs",
        "tw": "捷克文",
        "de": "Tschechisch",
        "jp": "チェコ語",
        "cn": "捷克语",
        "en": "Czech"
    },
    {
        "code": "da",
        "tw": "丹麥文",
        "de": "Dänisch",
        "jp": "デンマーク語",
        "cn": "丹麦语",
        "en": "Danish"
    },
    {
        "code": "de",
        "tw": "德文",
        "de": "Deutsch",
        "jp": "ドイツ語",
        "cn": "德语",
        "en": "German"
    },
    {
        "code": "el",
        "tw": "希臘文",
        "de": "Griechisch",
        "jp": "ギリシャ語",
        "cn": "希腊语",
        "en": "Greek"
    },
    {
        "code": "en-US",
        "tw": "英語(美國)",
        "de": "Englisch (USA)",
        "jp": "英語 (アメリカ)",
        "cn": "英语(美国)",
        "en": "English (United States)"
    },
    {
        "code": "en-GB",
        "tw": "英文（英國）",
        "de": "Englisch (Vereinigtes Königreich)",
        "jp": "英語 (イギリス)",
        "cn": "英语（英国）",
        "en": "English (United Kingdom)"
    },
    {
        "code": "en-IN",
        "tw": "英文（印度）",
        "de": "Englisch (Indien)",
        "jp": "英語 (インド)",
        "cn": "英语（印度）",
        "en": "English (India)"
    },
    {
        "code": "en",
        "tw": "英文",
        "de": "Englisch",
        "jp": "英語",
        "cn": "英语",
        "en": "English"
    },
    {
        "code": "es",
        "tw": "西班牙文",
        "de": "Spanisch",
        "jp": "スペイン語",
        "cn": "西班牙语",
        "en": "Spanish"
    },
    {
        "code": "es-419",
        "tw": "西班牙文（拉丁美洲）",
        "de": "Spanisch (Lateinamerika)",
        "jp": "スペイン語 (ラテンアメリカ)",
        "cn": "西班牙语（拉丁美洲）",
        "en": "Spanish (Latin America)"
    },
    {
        "code": "es-US",
        "tw": "西班牙文（美國）",
        "de": "Spanisch (Vereinigte Staaten)",
        "jp": "スペイン語 (アメリカ合衆国)",
        "cn": "西班牙语（美国）",
        "en": "Spanish (United States)"
    },
    {
        "code": "et",
        "tw": "愛沙尼亞文",
        "de": "Estnisch",
        "jp": "エストニア語",
        "cn": "爱沙尼亚语",
        "en": "Estonian"
    },
    {
        "code": "eu",
        "tw": "巴斯克文",
        "de": "Baskisch",
        "jp": "バスク語",
        "cn": "巴斯克语",
        "en": "Basque"
    },
    {
        "code": "fa",
        "tw": "波斯文",
        "de": "Persisch",
        "jp": "ペルシア語",
        "cn": "波斯语",
        "en": "Persian"
    },
    {
        "code": "fi",
        "tw": "芬蘭文",
        "de": "Finnisch",
        "jp": "フィンランド語",
        "cn": "芬兰语",
        "en": "Finnish"
    },
    {
        "code": "fil",
        "tw": "菲律賓文",
        "de": "Filipino",
        "jp": "フィリピノ語",
        "cn": "菲律宾语",
        "en": "Filipino"
    },
    {
        "code": "fr-CA",
        "tw": "法文（加拿大）",
        "de": "Französisch (Kanada)",
        "jp": "フランス語 (カナダ)",
        "cn": "法语（加拿大）",
        "en": "French (Canada)"
    },
    {
        "code": "fr",
        "tw": "法文",
        "de": "Französisch",
        "jp": "フランス語",
        "cn": "法语",
        "en": "French"
    },
    {
        "code": "gl",
        "tw": "加利西亞文",
        "de": "Galicisch",
        "jp": "ガリシア語",
        "cn": "加利西亚语",
        "en": "Galician"
    },
    {
        "code": "gu",
        "tw": "古吉拉特文",
        "de": "Gujarati",
        "jp": "グジャラート語",
        "cn": "古吉拉特语",
        "en": "Gujarati"
    },
    {
        "code": "hi",
        "tw": "印地文",
        "de": "Hindi",
        "jp": "ヒンディー語",
        "cn": "印地语",
        "en": "Hindi"
    },
    {
        "code": "hr",
        "tw": "克羅埃西亞文",
        "de": "Kroatisch",
        "jp": "クロアチア語",
        "cn": "克罗地亚语",
        "en": "Croatian"
    },
    {
        "code": "hu",
        "tw": "匈牙利文",
        "de": "Ungarisch",
        "jp": "ハンガリー語",
        "cn": "匈牙利语",
        "en": "Hungarian"
    },
    {
        "code": "hy",
        "tw": "亞美尼亞文",
        "de": "Armenisch",
        "jp": "アルメニア語",
        "cn": "亚美尼亚语",
        "en": "Armenian"
    },
    {
        "code": "id",
        "tw": "印尼文",
        "de": "Indonesisch",
        "jp": "インドネシア語",
        "cn": "印度尼西亚语",
        "en": "Indonesian"
    },
    {
        "code": "is",
        "tw": "冰島文",
        "de": "Isländisch",
        "jp": "アイスランド語",
        "cn": "冰岛语",
        "en": "Icelandic"
    },
    {
        "code": "it",
        "tw": "義大利文",
        "de": "Italienisch",
        "jp": "イタリア語",
        "cn": "意大利语",
        "en": "Italian"
    },
    {
        "code": "iw",
        "tw": "希伯來文",
        "de": "Hebräisch",
        "jp": "ヘブライ語",
        "cn": "希伯来语",
        "en": "Hebrew"
    },
    {
        "code": "ja",
        "tw": "日文",
        "de": "Japanisch",
        "jp": "日本語",
        "cn": "日语",
        "en": "Japanese"
    },
    {
        "code": "ka",
        "tw": "喬治亞文",
        "de": "Georgisch",
        "jp": "ジョージア語",
        "cn": "格鲁吉亚语",
        "en": "Georgian"
    },
    {
        "code": "kk",
        "tw": "哈薩克文",
        "de": "Kasachisch",
        "jp": "カザフ語",
        "cn": "哈萨克语",
        "en": "Kazakh"
    },
    {
        "code": "km",
        "tw": "高棉文",
        "de": "Khmer",
        "jp": "クメール語",
        "cn": "高棉语",
        "en": "Khmer"
    },
    {
        "code": "kn",
        "tw": "坎那達文",
        "de": "Kannada",
        "jp": "カンナダ語",
        "cn": "卡纳达语",
        "en": "Kannada"
    },
    {
        "code": "ko",
        "tw": "韓文",
        "de": "Koreanisch",
        "jp": "韓国語",
        "cn": "韩语",
        "en": "Korean"
    },
    {
        "code": "ky",
        "tw": "吉爾吉斯文",
        "de": "Kirgisisch",
        "jp": "キルギス語",
        "cn": "柯尔克孜语",
        "en": "Kyrgyz"
    },
    {
        "code": "lo",
        "tw": "寮文",
        "de": "Laotisch",
        "jp": "ラオ語",
        "cn": "老挝语",
        "en": "Lao"
    },
    {
        "code": "lt",
        "tw": "立陶宛文",
        "de": "Litauisch",
        "jp": "リトアニア語",
        "cn": "立陶宛语",
        "en": "Lithuanian"
    },
    {
        "code": "lv",
        "tw": "拉脫維亞文",
        "de": "Lettisch",
        "jp": "ラトビア語",
        "cn": "拉脱维亚语",
        "en": "Latvian"
    },
    {
        "code": "mk",
        "tw": "馬其頓文",
        "de": "Mazedonisch",
        "jp": "マケドニア語",
        "cn": "马其顿语",
        "en": "Macedonian"
    },
    {
        "code": "ml",
        "tw": "馬來亞拉姆文",
        "de": "Malayalam",
        "jp": "マラヤーラム語",
        "cn": "马拉雅拉姆语",
        "en": "Malayalam"
    },
    {
        "code": "mn",
        "tw": "蒙古文",
        "de": "Mongolisch",
        "jp": "モンゴル語",
        "cn": "蒙古语",
        "en": "Mongolian"
    },
    {
        "code": "mr",
        "tw": "馬拉地文",
        "de": "Marathi",
        "jp": "マラーティー語",
        "cn": "马拉地语",
        "en": "Marathi"
    },
    {
        "code": "ms",
        "tw": "馬來文",
        "de": "Malaiisch",
        "jp": "マレー語",
        "cn": "马来语",
        "en": "Malay"
    },
    {
        "code": "my",
        "tw": "緬甸文",
        "de": "Birmanisch",
        "jp": "ミャンマー語",
        "cn": "缅甸语",
        "en": "Burmese"
    },
    {
        "code": "no",
        "tw": "挪威文",
        "de": "Norwegisch",
        "jp": "ノルウェー語",
        "cn": "挪威语",
        "en": "Norwegian"
    },
    {
        "code": "ne",
        "tw": "尼泊爾文",
        "de": "Nepalesisch",
        "jp": "ネパール語",
        "cn": "尼泊尔语",
        "en": "Nepali"
    },
    {
        "code": "nl",
        "tw": "荷蘭文",
        "de": "Niederländisch",
        "jp": "オランダ語",
        "cn": "荷兰语",
        "en": "Dutch"
    },
    {
        "code": "or",
        "tw": "歐迪亞文",
        "de": "Oriya",
        "jp": "オディア語",
        "cn": "奥里亚语",
        "en": "Odia"
    },
    {
        "code": "pa",
        "tw": "旁遮普文",
        "de": "Punjabi",
        "jp": "パンジャブ語",
        "cn": "旁遮普语",
        "en": "Punjabi"
    },
    {
        "code": "pl",
        "tw": "波蘭文",
        "de": "Polnisch",
        "jp": "ポーランド語",
        "cn": "波兰语",
        "en": "Polish"
    },
    {
        "code": "pt",
        "tw": "葡萄牙文",
        "de": "Portugiesisch",
        "jp": "ポルトガル語",
        "cn": "葡萄牙语",
        "en": "Portuguese"
    },
    {
        "code": "pt-PT",
        "tw": "葡萄牙文（葡萄牙）",
        "de": "Portugiesisch (Portugal)",
        "jp": "ポルトガル語 (ポルトガル)",
        "cn": "葡萄牙语（葡萄牙）",
        "en": "Portuguese (Portugal)"
    },
    {
        "code": "ro",
        "tw": "羅馬尼亞文",
        "de": "Rumänisch",
        "jp": "ルーマニア語",
        "cn": "罗马尼亚语",
        "en": "Romanian"
    },
    {
        "code": "ru",
        "tw": "俄文",
        "de": "Russisch",
        "jp": "ロシア語",
        "cn": "俄语",
        "en": "Russian"
    },
    {
        "code": "si",
        "tw": "僧伽羅文",
        "de": "Singhalesisch",
        "jp": "シンハラ語",
        "cn": "僧伽罗语",
        "en": "Sinhala"
    },
    {
        "code": "sk",
        "tw": "斯洛伐克文",
        "de": "Slowakisch",
        "jp": "スロバキア語",
        "cn": "斯洛伐克语",
        "en": "Slovak"
    },
    {
        "code": "sl",
        "tw": "斯洛維尼亞文",
        "de": "Slowenisch",
        "jp": "スロベニア語",
        "cn": "斯洛文尼亚语",
        "en": "Slovenian"
    },
    {
        "code": "sq",
        "tw": "阿爾巴尼亞文",
        "de": "Albanisch",
        "jp": "アルバニア語",
        "cn": "阿尔巴尼亚语",
        "en": "Albanian"
    },
    {
        "code": "sr-Latn",
        "tw": "塞爾維亞文（拉丁文）",
        "de": "Serbisch (Lateinisch)",
        "jp": "セルビア語 (ラテン文字)",
        "cn": "塞尔维亚语（拉丁文）",
        "en": "Serbian (Latin)"
    },
    {
        "code": "sr",
        "tw": "塞爾維亞文",
        "de": "Serbisch",
        "jp": "セルビア語",
        "cn": "塞尔维亚语",
        "en": "Serbian"
    },
    {
        "code": "sv",
        "tw": "瑞典文",
        "de": "Schwedisch",
        "jp": "スウェーデン語",
        "cn": "瑞典语",
        "en": "Swedish"
    },
    {
        "code": "sw",
        "tw": "史瓦希里文",
        "de": "Suaheli",
        "jp": "スワヒリ語",
        "cn": "斯瓦希里语",
        "en": "Swahili"
    },
    {
        "code": "ta",
        "tw": "坦米爾文",
        "de": "Tamil",
        "jp": "タミル語",
        "cn": "泰米尔语",
        "en": "Tamil"
    },
    {
        "code": "te",
        "tw": "泰盧固文",
        "de": "Telugu",
        "jp": "テルグ語",
        "cn": "泰卢固语",
        "en": "Telugu"
    },
    {
        "code": "th",
        "tw": "泰文",
        "de": "Thailändisch",
        "jp": "タイ語",
        "cn": "泰语",
        "en": "Thai"
    },
    {
        "code": "tr",
        "tw": "土耳其文",
        "de": "Türkisch",
        "jp": "トルコ語",
        "cn": "土耳其语",
        "en": "Turkish"
    },
    {
        "code": "uk",
        "tw": "烏克蘭文",
        "de": "Ukrainisch",
        "jp": "ウクライナ語",
        "cn": "乌克兰语",
        "en": "Ukrainian"
    },
    {
        "code": "ur",
        "tw": "烏都文",
        "de": "Urdu",
        "jp": "ウルドゥー語",
        "cn": "乌尔都语",
        "en": "Urdu"
    },
    {
        "code": "uz",
        "tw": "烏茲別克文",
        "de": "Usbekisch",
        "jp": "ウズベク語",
        "cn": "乌兹别克语",
        "en": "Uzbek"
    },
    {
        "code": "vi",
        "tw": "越南文",
        "de": "Vietnamesisch",
        "jp": "ベトナム語",
        "cn": "越南语",
        "en": "Vietnamese"
    },
    {
        "code": "zh",
        "tw": "中文",
        "de": "Chinesisch",
        "jp": "中国語",
        "cn": "中文",
        "en": "Chinese"
    },
    {
        "code": "zh-CN",
        "tw": "中文（中國）",
        "de": "Chinesisch (China)",
        "jp": "中国語 (中国)",
        "cn": "中文（中国）",
        "en": "Chinese (China)"
    },
    {
        "code": "zh-HK",
        "tw": "中文（香港）",
        "de": "Chinesisch (Hongkong)",
        "jp": "中国語 (香港)",
        "cn": "中文（香港）",
        "en": "Chinese (Hong Kong)"
    },
    {
        "code": "zh-TW",
        "tw": "中文（台灣）",
        "de": "Chinesisch (Taiwan)",
        "jp": "中国語 (台湾)",
        "cn": "中文（台湾）",
        "en": "Chinese (Taiwan)"
    },
    {
        "code": "zh-Hant",
        "tw": "中文(繁體)",
        "de": "Traditionelles Chinesisch",
        "jp": "中国語 (繁体字)",
        "cn": "中文(繁体)",
        "en": "Chinese (Traditional)"
    },
    {
        "code": "zh-Hans",
        "tw": "中文(簡體)",
        "de": "Vereinfachtes Chinesisch",
        "jp": "中国語 (簡体字)",
        "cn": "中文(简体)",
        "en": "Chinese (Simplified)"
    },
    {
        "code": "zu",
        "tw": "祖魯文",
        "de": "Zulu",
        "jp": "ズールー語",
        "cn": "祖鲁语",
        "en": "Zulu"
    }
]
export function languageCodeToName (languageCodeList, lang = "en") {
    if (!languageCodeList) {
        return "";
    }
    return languageCodeList.map(code => languages.find(language => code === language.code)?.[lang]).filter(name => name != undefined).join(", ");
}